import React from 'react';
import './LoadingBlock.css';
import {Skeleton} from "antd";

export const LoadingSkeleton = React.memo(({nLoop = 2}) => {
    return (
        <div className="mt-16 p-6 space-y-6">
            {Array.from({length: nLoop}).map((_, i) => (
                <div
                    key={i}
                    className="mb-6 last:mb-0 pb-6 border-b border-gray-100 last:border-0">
                    <Skeleton loading={true} active/>
                </div>
            ))}
        </div>
    );
});

export const LoadingSkeletonContent = React.memo(({}) => {
    return (
        <div className="mb-6 m-3 last:mb-0 pb-6 border-b border-gray-100 last:border-0">
            <Skeleton loading={true} active>

            </Skeleton>
        </div>
    )
})
